import React from 'react';
import { DialogActions, Button, Typography } from '@mui/material';
import {
  ConfirmationDialog as StyledConfirmationDialog,
  ConfirmationContent
} from './styled';
import pallet from '../../layouts/pallet';

export interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message: string;
  disable?: boolean;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  message,
  disable
}) => {
  return (
    <StyledConfirmationDialog
      open={open}
      onClose={onClose}
      maxWidth='sm'
      fullWidth
    >
      <ConfirmationContent>
        <Typography variant='body1' sx={{ mb: 2 }}>
          {message}
        </Typography>
      </ConfirmationContent>

      <DialogActions sx={{ p: 0 }}>
        <Button
          onClick={onClose}
          sx={{ border: `1px solid ${pallet.primary}` }}
        >
          No, Cancel
        </Button>
        <Button onClick={onConfirm} variant='contained' disabled={disable}>
          Yes, Continue
        </Button>
      </DialogActions>
    </StyledConfirmationDialog>
  );
};

export default ConfirmationDialog;
